import { hotTags } from '@/mocks/articles';
import SectionTitle from '@/components/base/SectionTitle';

export default function HotTopics() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          title="热搜话题"
          subtitle="全网最火的吃瓜关键词，点击追踪最新动态"
        />
        <div className="flex flex-wrap gap-3">
          {hotTags.map((tag) => (
            <button
              key={tag.id}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-100 text-foreground-700 hover:text-primary-700 text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              {tag.name}
              <span className="text-xs text-foreground-400 group-hover:text-primary-400">
                {tag.热度 > 10000 ? `${(tag.热度 / 10000).toFixed(1)}万` : tag.热度}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}